import { version } from '../../package.json';

export const environment = {
    production: false,
    appVersion: version,
    notificationsUrl: 'https://prd-genesis.avion.avionsoftware.io/api/avion/GetAppNotifications',
    authority: 'https://uat-genesis.sal.avionsoftware.io/',
    apiBase: 'https://uat-genesis.sal.avionsoftware.io',
    clientId: 'ngSALTraining',
    scope: 'openid profile email groups offline_access training.scope',
    documentationBaseUrl: 'https://docs.avionsoftware.com/sal-training?q=',
    downloadAttachmentUrl: 'https://sal.avionsoftware.com/avalon/avalon/administration/downloadattachment',
};
